import React from 'react'
import { Row, Col } from 'antd'

export const ButtonContainer = ({ children }) => (
  <Row justify='end' align='middle' className='stretched'>
    <Col>{children}</Col>
  </Row>
)
